import React from 'react';
import { OrganizationTabParamList } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { RouteProp } from '@react-navigation/native';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import useOrganizationInvitationDefinitions from '../../../../../hooks/api/useOrganizationInvitationDefinitions';
import InvitationDefinitionDetails from '../../../../shared/InvitationDefinitions/InvitationDefinitionDetails';

export type InvitationDefinitionScreenOwnProps = {};

export type InvitationDefinitionScreenProps = InvitationDefinitionScreenOwnProps & {
    route: RouteProp<OrganizationTabParamList, 'invitation-template'>;
};

const InvitationDefinitionScreen: React.FC<InvitationDefinitionScreenProps> = (props) => {
    const { invitationDefinition, isLoadingInvitationDefinition } = useOrganizationInvitationDefinitions({
        invitationDefinitionId: props.route.params.invitationTemplateId,
    });
    return (
        <AnimateLoadedContent isLoading={!invitationDefinition || isLoadingInvitationDefinition}>
            {() => (
                <ActionButtonLayout scrollable>
                    <MainContentContainer>
                        <InvitationDefinitionDetails invitationDefinitionId={props.route.params.invitationTemplateId} />
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(InvitationDefinitionScreen);
